import { queryOptions, useQuery } from '@tanstack/react-query';

import { api, extractData } from '@/lib/treaty';

export type SearchAllQueryFilters = Parameters<typeof api.search.get>;

export const getSearchAll = (...args: SearchAllQueryFilters) => {
  return extractData(api.search.get(...args));
};

export type SearchAllResult = Awaited<ReturnType<typeof getSearchAll>>;

export const getSearchAllQueryOptions = (...args: SearchAllQueryFilters) =>
  queryOptions({
    queryKey: ['search', 'all', ...args],
    queryFn: () => getSearchAll(...args),
  });

export const useSearchAll = (...args: SearchAllQueryFilters) => {
  return useQuery({ ...getSearchAllQueryOptions(...args) });
};
